<div>{{ currencyDisplay }}</div>
<ts-number-input
  [config]="config"
  [value]="moneyAsNumber"
  (valueChange)="inputChanged($event)"
></ts-number-input>
